export const GET_USERDETAILS_REQUEST = 'admin/GET_USERDETAILS_REQUEST';
export const GET_USER_PAGINATE_DETAILS_REQUEST = 'admin/GET_USER_PAGINATE_DETAILS_REQUEST';
export const GET_USERDETAILS_FAIL = 'admin/GET_USERDETAILS_FAIL';
export const GET_USERDETAILS_RESPONSE = 'admin/GET_USERDETAILS_RESPONSE';
export const FLIP_USER_CARD = 'admin/FLIP_USER_CARD';
export const HIDE_MODAL = 'admin/HIDE_MODAL';
